import { exists } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
    if (!node) return false;

    let state = {
        node,
        config,
        topBar: node.querySelector(`.c-nav__top`),
        bottomBar: node.querySelector(`.c-nav__bottom`),
    };

    let module = {
        makeLayout() {
            let numCols = parseInt(state.node.dataset.cols);
            let colHeights = Array(numCols).fill(0);
            let container = state.node;

            if (!state.node.children.length) return;

            [...state.node.children].map((child, index) => {
                let order = index % numCols;
                
                child.style.order = order;

                colHeights[order] += parseFloat(child.offsetHeight);
            });

            container.style.height = Math.max(...colHeights) + 10 + 'px';
        },
        destroyLayout() {
            state.node.style.removeProperty('height');

            [...state.node.children].map((child, index) => {
                child.style.removeProperty('order');
            });
        },
        onWindowResize() {
            if (window.innerWidth < 768) {
                this.destroyLayout();
            } else {
                this.makeLayout();
            }
            
        },
        setEventBindings() {
            window.addEventListener('resize', this.onWindowResize.bind(this)); 
        },
        init() {
            if (!exists(state.node)) return;
            this.setEventBindings();
            if (window.innerWidth < 768) return;
            this.makeLayout();
        },
    };

    return module.init();
};

export default {
    init({ selector, config = {} }) {
        let selected = document.querySelectorAll(selector);
        if (!selected.length) return;

        return [...selected].map((node, index) => {
            return mixin({ node, config });
        });
    },
};
